const CatgoryService = {
    getActive : (categories) => categories ?  categories.filter(currency => currency.state ==='ACTIVE') : []
}

export default CatgoryService